"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShortcutSymbol = void 0;
const getShortcutSymbol = () => {
    // If we can detect Mac then we return "⌘" otherwise default to "Ctrl"
    return window.navigator.userAgent.toLowerCase().indexOf('mac') > -1 ? '⌘' : 'Ctrl';
};
exports.getShortcutSymbol = getShortcutSymbol;
